import React, {
  useContext,
} from 'react';
import {
  VisitNoteServiceCode,
} from 'views/EMR/components/ServiceLookup/type';
import {
  VirtualTableColumnDef as ColumnDef,
  EditableTableMeta,
} from 'core/components/VirtualTable/types';
import {
  CellContext,
} from '@tanstack/react-table';
import {
  ServiceContext,
} from 'views/EMR/components/ServiceLookup/ServiceContext';
import {
  CodeWithDescription,
} from 'views/EMR/components/ServiceLookup/columns/serviceName';

function CodeCell({ row, table }: CellContext<VisitNoteServiceCode, unknown>) {
  const { removeData } = table.options.meta as EditableTableMeta<VisitNoteServiceCode>;
  const { description, code } = row.original ?? {};
  const { readonly } = useContext(ServiceContext);

  return (
    <CodeWithDescription
      value={code ?? ''}
      description={description ?? ''}
      readonly={readonly}
      classes={{ root: '!w-full', chipWrapper: 'flex-1' }}
      onRemove={() => { removeData?.(row.index, row.original); }}
    />
  );
}

export default {
  id: 'code',
  accessorKey: 'code',
  header: 'Service',
  meta: { autoSized: true },
  minSize: 120,
  cell: CodeCell,
} as ColumnDef<VisitNoteServiceCode>;
